import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const MarginTopIcon = (props?: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M13.5 5.83203H6.5C5.09987 5.83203 4.3998 5.83203 3.86502 6.02883C3.39462 6.20193 3.01217 6.47814 2.77248 6.81788C2.5 7.20411 2.5 7.70971 2.5 8.72092V13.7765C2.5 14.7877 2.5 15.2933 2.77248 15.6795C3.01217 16.0193 3.39462 16.2955 3.86502 16.4686C4.3998 16.6654 5.09987 16.6654 6.5 16.6654H10H13.5C14.9001 16.6654 15.6002 16.6654 16.135 16.4686C16.6054 16.2955 16.9878 16.0193 17.2275 15.6795C17.5 15.2933 17.5 14.7877 17.5 13.7765V8.72092C17.5 7.70971 17.5 7.20411 17.2275 6.81788C16.9878 6.47814 16.6054 6.20193 16.135 6.02883C15.6002 5.83203 14.9001 5.83203 13.5 5.83203Z"
      stroke="var(--color-iconTertiary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5827 2.5H9.99935H5.41602"
      stroke="var(--color-iconTertiary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
